import React, { useRef } from 'react';
import { ContractItems } from '../../../../Interfaces/Accounting/JobsContracts.interface';
import JCDrilldownReport from '../JCReport/JCDrilldownReport';
import ContractItemsTable from './ContractItemsTable';

type CIDrilldownContentProps = {
  items: ContractItems[];
  contract: string;
  contractName: string;
};

const CIDrilldownContent = ({
  items,
  contract,
  contractName,
}: CIDrilldownContentProps) => {
  const drilldownRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      id="jc-contract-item-drilldown"
      ref={drilldownRef}
      className="blackText text-standard printBackground w-full max-w-1100px pdfDivFitContent"
    >
      <div className="mt-3 px-4 flex justify-content-center sm:justify-content-between gap-3 flex-wrap capitalize">
        <div className="text-28px font-bold flex-grow-1 text-center sm:text-left">
          <div className="mx-auto w-fit sm:ml-0 drilldownHeader">
            JC Contract Items Drilldown
          </div>
          <div className="text-23px mt-3 mr-auto w-fit">
            Contract {contract} {contractName}
          </div>
        </div>
        <div className="text-23px mx-auto md:ml-4 md:mr-2 mt-2 sm:mt-0 cursor-pointer printHide flex align-items-center">
          <JCDrilldownReport
            title="JC Contract Items Drilldown"
            elementRef={drilldownRef}
            isPortrait={true}
            fileName="JC_Items_Drilldown_Report"
            elementID="jc-contract-item-drilldown"
            costDetail={{ contract, contractName }}
          />
        </div>
      </div>
      <div className="my-4" />
      <ContractItemsTable items={items} drilldownStyles={true} />
    </div>
  );
};

export default CIDrilldownContent;
